const MobileMenuCrossIcon = ({ size = 22, color = "#EDD2B9", className = "", ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      className={className}
      {...props}
    >
      <path d="M1 1L20.799 20.799" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M1 20.7988L20.799 0.999839" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default MobileMenuCrossIcon;
